import { IMAGES } from "../../data/content";
import { Reveal, Eyebrow } from "../motion";

const SKILLS = ["Stratégie", "Immobilier", "Technique", "Travaux", "Architecture", "Décoration", "Exploitation", "Communication", "Marketing"];

export const Differentiation = () => (
  <section className="py-24 lg:py-36" data-testid="section-differenciation">
    <div className="mx-auto max-w-[1500px] px-6 sm:px-10 lg:px-16">
      <div className="grid gap-14 lg:grid-cols-12 lg:items-center">
        <div className="lg:col-span-7">
          <Reveal>
            <Eyebrow>Notre différenciation</Eyebrow>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-6 font-serif text-4xl leading-[1.12] text-cream sm:text-5xl">
              Vous n'êtes pas accompagné par une seule personne. Vous avez une équipe autour de votre projet.
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-8 leading-relaxed text-white/55">
              La réussite d'un projet immobilier atypique nécessite plusieurs compétences : stratégie, immobilier,
              technique, travaux, architecture, décoration, exploitation, communication et marketing.
            </p>
          </Reveal>
          <Reveal delay={0.22}>
            <p className="mt-4 leading-relaxed text-white/55">
              C'est pour cette raison que Demoiselle Atypique s'appuie sur une équipe aux compétences complémentaires.
            </p>
          </Reveal>
          <Reveal delay={0.28}>
            <ul className="mt-10 flex flex-wrap gap-3" data-testid="differenciation-competences">
              {SKILLS.map((s) => (
                <li key={s} className="border border-white/15 px-4 py-2 font-mono text-[10px] uppercase tracking-[0.2em] text-white/70 transition-colors hover:border-neon hover:text-neon">
                  {s}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
        <Reveal delay={0.15} className="lg:col-span-5">
          <div className="relative aspect-[4/5] overflow-hidden">
            <img
              src={IMAGES.differenciation}
              alt="La Pomme d'Amour — suite prestige avec écran de projection, rayures rouge et blanc et pop-corn : un univers complet créé par nos clients accompagnés"
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/50 to-transparent" />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
